import { render, staticRenderFns } from "./TenantUserFormDialog.vue?vue&type=template&id=640cf030"
import script from "./TenantUserFormDialog.vue?vue&type=script&lang=js"
export * from "./TenantUserFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports